import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["loading", "disabled", "invalid", "inline", "rightAdornment", "size", "width", "minWidth", "maxWidth", "dateInputRef", "maskInputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { IconFunctionalCalendar16 } from '@cian/ui-kit-design-tokens/icons';
import { InputAdornment } from '../../../../inputAdornment';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { InputWrapperInput } from '../../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../../internal/components/FocusObserver/FocusObserver';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType/useDeviceType';
import { NativeDateMaskInput } from '../NativeDateMaskInput';
import { NativeDateInput } from '../NativeDateInput';
import styles from './styles.module.css';
import { FocusSource } from '../../../../internal/types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateInputInput = /*#__PURE__*/React.forwardRef(function DateInputInput(props, ref) {
  const {
      loading,
      disabled,
      invalid,
      inline,
      rightAdornment,
      size,
      width,
      minWidth,
      maxWidth,
      dateInputRef,
      maskInputRef
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [focus, setFocus] = React.useState({
    focused: false,
    source: FocusSource.mouse
  });
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const handleFocus = (focused, source) => {
    setFocus({
      focused,
      source
    });
  };
  return /*#__PURE__*/_jsxs(InputWrapper, {
    ref: ref,
    focused: focus.focused,
    focusSource: focus.source,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: /*#__PURE__*/_jsx(InputAdornment, {
      children: /*#__PURE__*/_jsx(IconFunctionalCalendar16, {
        color: "icon-main-default"
      })
    }),
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    className: clsx(styles['wrapper'], isMobile && styles['mobile']),
    children: [/*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(NativeDateMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
        ref: maskInputRef,
        as: InputWrapperInput,
        className: styles['input-mask'],
        disabled: props.disabled,
        name: undefined
      }))
    }), /*#__PURE__*/_jsx(NativeDateInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: dateInputRef,
      className: styles['input-date']
    }))]
  });
});